module.exports = __webpack_public_path__ + "img/cloud.2e026275.svg";